import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import '../styles/Login.css';
function LoginPage() {
  const [mode, setMode] = useState<'signin' | 'signup' | 'reset'>('signin');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setMessage('');
    if (!email || (!password && mode !== 'reset')) {
      setMessage(mode === 'reset' ? 'Enter your email.' : 'Enter your email and password.');
      return;
    }
    if (mode === 'signup' && !firstName.trim()) {
      setMessage('Enter your first name.');
      return;
    }
    setBusy(true);
    if (mode === 'reset') {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset`,
      });
      if (error) setMessage(error.message);
      else
        setMessage(
          'Reset link sent. Check your email (and junk folder), then follow the link.'
        );
      setBusy(false);
      return;
    }
    if (mode === 'signin') {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) setMessage(error.message);
    } else {
      const { error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            first_name: firstName.trim(),
          },
        },
      });
      if (error) setMessage(error.message);
      else setMessage('Account created. You can sign in now.');
    }
    setBusy(false);
  };
  const googleSignIn = async () => {
    setMessage('');
    setBusy(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin,
      },
    });
    if (error) {
      setMessage(error.message);
      setBusy(false);
    }
  };
  return (
    <div className="login-page">
      <div className="login-card">
        <img
          src="/logo.png"
          alt="Lighthouse Hunters"
          className="login-logo"
        />
        <p className="login-tagline">Australia's verified lighthouse passport</p>
        {mode === 'signup' && (
          <input
            type="text"
            placeholder="First name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            autoComplete="given-name"
          />
        )}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {mode !== 'reset' && (
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
          />
        )}
        <button className="btn-primary" onClick={submit} disabled={busy}>
          {busy
            ? 'Working...'
            : mode === 'signin'
            ? 'Sign In'
            : mode === 'signup'
            ? 'Create Account'
            : 'Send Reset Link'}
        </button>
        {mode !== 'reset' && (
          <button
            type="button"
            className="btn-google"
            onClick={googleSignIn}
            disabled={busy}
          >
            <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            </svg>
            Continue with Google
          </button>
        )}
        {message && <p className="login-message">{message}</p>}
        {mode === 'signin' && (
          <button
            className="login-switch"
            onClick={() => {
              setMode('reset');
              setMessage('');
            }}
          >
            Forgot password?
          </button>
        )}
        <button
          className="login-switch"
          onClick={() => {
            setMode(mode === 'signin' ? 'signup' : 'signin');
            setMessage('');
          }}
        >
          {mode === 'signin'
            ? 'New member? Create an account'
            : 'Already a member? Sign in'}
        </button>
      </div>
    </div>
  );
}
export default LoginPage;
